import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../../api/client';
import { Section } from '../../../components/ui/Section';

interface HealthData {
  status: string;
  db: { connected: boolean; latencyMs: number | null };
  uptime: { seconds: number };
  node: string;
  timestamp: string;
}

export default function SystemHealthSection() {
  const { data: health } = useQuery<HealthData>({
    queryKey: ['system-health'],
    queryFn: () => apiGet<HealthData>('/user-settings/health'),
    refetchInterval: 60000,
  });

  const uptimeStr = (seconds: number): string => {
    if (seconds < 3600) return `${Math.floor(seconds / 60)} min`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}min`;
    return `${Math.floor(seconds / 86400)}g ${Math.floor((seconds % 86400) / 3600)}h`;
  };

  return (
    <Section title="System Health" collapsible defaultOpen={false}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.625rem' }}>
          <span style={{
            display: 'inline-block', width: 8, height: 8, borderRadius: '50%',
            background: health?.db.connected ? 'var(--color-success)' : 'var(--color-error)',
          }} />
          <span style={{ fontSize: 'var(--text-sm)' }}>
            DB: {health?.db.connected ? 'Connesso' : 'Disconnesso'}
            {health?.db.latencyMs != null && ` (${health.db.latencyMs}ms)`}
          </span>
        </div>
        <div style={{ fontSize: 'var(--text-sm)' }}>
          Uptime: {health ? uptimeStr(health.uptime.seconds) : '…'}
        </div>
        <div style={{ fontSize: 'var(--text-sm)' }}>
          Node.js: {health?.node ?? '…'}
        </div>
        <div style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-faint)' }}>
          Aggiornato: {health ? new Date(health.timestamp).toLocaleString('it-IT') : '…'}
        </div>
      </div>
    </Section>
  );
}
